import React, { Fragment } from 'react'
import Component from 'components/component'
import Dropdown from 'components/dropdown'
import Validator from 'components/validator'

export default class Select extends Component {
  static defaultProps = {
    isRequired: false,
    validators: [],
    getTitle: item => item.title,
    getValue: item => item.value,
    wrapSelect: false,
    disabled: false,
  }

  get validators() {
    return [this.props.isRequired && 'isRequired', ...this.props.validators]
  }

  renderSelect(value) {
    return (
      <Dropdown
        getTitle={this.props.getTitle}
        getValue={this.props.getValue}
        items={this.props.items}
        name={this.props.name}
        value={value}
        placeholder={this.props.placeholder}
        modificator={this.props.modificator}
        headerModificator={this.props.headerModificator}
        notSelected={this.props.notSelected}
        isInput={this.props.isInput}
        disabled={this.props.disabled}
      />
    )
  }

  render() {
    return (
      <Validator
        onValidateForm={this.props.onValidateForm}
        value={this.props.value || ''}
        validators={this.validators}
        render={({ value, hasError, isValid, messages }) => (
          <Fragment>
            {this.props.wrapSelect ? (
              <div className="field">{this.renderSelect(value)}</div>
            ) : (
              this.renderSelect(value)
            )}
            {hasError && <div className="error">{messages[0]}</div>}
          </Fragment>
        )}
      />
    )
  }
}
